<div class="container-fluid">
	<div class="row my-3">
		<div class="col-12 col-lg-6 col-xl-8">
			<h1 class="my-3">Datos de la orden #{{order_info?.order?.id}}</h1>
			<div class="card p-3">
				<div class="row" *ngIf="order_info">
					<div class="col-6 col-md-4">
						<label class="">Cliente:</label>
						<div>
							<img [src]="rest.getImagePath(order_info?.client?.image_id, rest.local_preferences?.default_user_logo_image_id)" style="max-width:30px;max-height:30px;margin-right:10px;">
							<a *ngIf="order_info?.client" [routerLink]="['/view-client',order_info.order.client_user_id]">{{order_info.client.name}}</a>
							<b *ngIf="!(order_info?.order?.client_user_id)">{{order_info.order.client_name}}</b>
						</div>
					</div>
					<div class="col-6 col-md-4 py-2" *ngIf="order_info">
						<label class="">Estatus:</label>
						<div class="fw-bold">
							<span *ngIf="order_info.order.status=='PENDING'">SIN CONFIRMAR</span>
							<span *ngIf="order_info.order.status=='ACTIVE'">EN CURSO</span>
							<span *ngIf="order_info.order.status=='CLOSED'">CERRADA</span>
							<span *ngIf="order_info.order.status=='CANCELLED'">CANCELADA</span>
						</div>
					</div>
					<div class="col-6 col-md-4 py-2">
						<label>Atendió</label>
						<div class="fw-bold">
							<img [src]="rest.getImagePath(order_info?.cashier?.image_id, rest.local_preferences?.default_user_logo_image_id)" style="max-width:30px;max-height:30px;margin-right:10px;">
							{{order_info.cashier?.name}}
						</div>
					</div>
					<div class="col-6 col-md-4 py-2">
						<label class="">Almacén</label>
						<div class="fw-bold">{{order_info.store?.name | titlecase}}</div>
					</div>
					<div class="col-6 col-md-4 py-2">
						<label class="">Fecha Creación</label>
						<div class="fw-bold">{{order_info.order.created | shortDate:'full'}}</div>
					</div>
					<div class="col-6 col-md-4 py-2"	*ngIf="order_info.order.closed_timestamp">
						<label class="">Cerrada</label>
						<div class="fw-bold">{{order_info.order.closed_timestamp | shortDate:'full'}}</div>
					</div>
					<div class="col-6 col-md-4 py-2">
						<label class="">Fecha Activación</label>
						<div class="fw-bold">{{order_info.order.system_activated| shortDate:'full'}}</div>
					</div>
					<div class="col-6 col-md-4 py-2">
						<label class="">Código Facturación</label>
						<div class="fw-bold"> {{order_info.order.facturacion_code }}</div>
					</div>
					<div class="col-6 col-md-4 py-2" *ngIf="order_info.order.quote_id">
						<label class="">Cotización</label>
						<div class="fw-bold">
							<a [routerLink]="['/view-quote',order_info.order.quote_id]">#{{order_info.order.quote_id}}</a>
						</div>
					</div>
					<div class="col-6 col-md-4 py-2" *ngIf="order_info?.price_type">
						<label class="">Tipo de Consumo:</label>
						<div class="fw-bold">{{order_info.price_type.name | uppercase}}</div>
					</div>
					<div class="col-6 col-md-4 py-2" *ngIf="cancel_user">
						<label class="">Cancelado por:</label>
						<div class="fw-bold">{{ cancel_user.name }}</div>
					</div>
					<div class="col-6 col-md-4 py-2" *ngIf="order_info.order.cancellation_reason">
						<label class="">Motivo de Cancelación:</label>
						<div class="fw-bold">{{ order_info.order.cancellation_reason }}</div>
					</div>
					<div class="col-12 py-2" *ngIf="order_info.order.note">
						<label class="">Nota / Comentarios:</label>
						<div class="fw-bold">{{ order_info.order.note }}</div>
					</div>
					<div class="col-6 col-md-3 py-2" *ngIf="!is_loading && ((rest.current_permission.cancel_closed_orders && order_info.order.status == 'CLOSED') || order_info.order.status == 'PENDING')">
						<div>
							<button class="btn btn-primary w-100" type="button" (click)="show_confirm_cancel=true">Cancelar Orden</button>
						</div>
					</div>
					<div class="col-6 col-md-3 py-2" *ngIf="order_info.order.delivery_status != 'DELIVERED' && order_info.order.status != 'CANCELLED'">
						<div>
							<button class="btn btn-success w-100" type="button" (click)="confirmDeliverOrder($event)">Entregar Todo</button>
						</div>
					</div>
					<div class="col-6 col-md-3 py-2" *ngIf="rest.local_preferences.comex_enabled && !order_info.order.external_id">
						<button class="btn btn-primary w-100" type="button" (click)="acumulaVentaComex($event)">Acumular Venta</button>
					</div>
					<div class="col-6 col-md-3 py-2" *ngIf="rest.local_preferences.comex_enabled && order_info.order.external_id">
						<button class="btn btn-primary w-100" type="button" (click)="cancelarComex($event)">Cancelar Comex</button>
					</div>
					<div class="col-6 col-md-3 py-2" *ngIf="rest.local_preferences.comex_enabled">
						<button class="btn btn-primary w-100" type="button" (click)="duplicateOrder($event)">Duplicar</button>
					</div>
					<div class="col-6 col-md-3 py-2" *ngIf="rest.has_ares && !order_info.order.ares && !order_info.order.sat_factura_id">
						<button class="btn btn-primary w-100" type="button" (click)="applyAres($event)">Invalidar Orden</button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-lg-6 col-xl-4">
			<h2 class="my-3">Facturación</h2>
			<div class="card py-3 px-0">
				<div class="row m-0">
					<div class="col-12 px-3 mb-2" *ngIf="order_info.order.facturacion_mode == 'PER_PAYMENT'">
						<span class="badge bg-primary">
							Facturación por pago (PER_PAYMENT)
						</span>
					</div>
					<div class="col-12 col-sm-6 mb-1">
						<!--button (click)="testPrint($event)">
							Test
						</button-->
						<button class="btn btn-primary w-100" *ngIf="rest.has_printers" (click)="printUsbExterna($event)">Print</button>
						<a *ngIf="order_info.order.id" class="btn btn-primary w-100" [routerLink]="['/print-receipt', rest.has_printers ? '8' : (this.store.print_receipt || rest.local_preferences.default_print_receipt),order_info.order.id]">
							Ver Ticket
						</a>
						<a *ngIf="!order_info.order.id" class="btn btn-primary w-100 " [routerLink]="['/print-receipt-offline', rest.has_printers ? '8' : (this.store.print_receipt || rest.local_preferences.default_print_receipt),order_info.order.sync_id]">
							Ver Ticket
						</a>
					</div>
					<div class="col-12 col-sm-6 mb-1">
						<a class="btn btn-primary w-100" [routerLink]="['/print-remission',order_info.order.id]">Ver Remisión</a>
					</div>
					<div class="col-12 col-sm-6 mb-1" *ngIf="order_info.order.id && rest.local_preferences.funeraria_enabled">
						<a class="btn btn-outline-secondary w-100" [routerLink]="['/print-funeraria',order_info.order.id]" target="_blank">Imprimir Contrato</a>
					</div>

					<div class="col-12 col-sm-6 mb-1" *ngIf="!order_info.sat_factura?.uuid && !order_info?.sat_factura?.request && order_info.order.status == 'CLOSED' && order_info.order.facturacion_mode != 'PER_PAYMENT'">
						<button class="btn btn-primary w-100" type="button" (click)="showFacturar($event)">
							Facturar
						</button>
					</div>

					<div class="col-12 col-sm-6 mb-1" *ngIf="order_info.sat_factura && !order_info.sat_factura.uuid && order_info.sat_factura?.request">
						<button class="btn btn-primary w-100" type="button" (click)="replayFactura()">
							Facturar
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m6 10.74c-.12 3.09-2.67 5.64-5.76 5.76a5.995 5.995 0 0 1-6.12-4.82c-.13-.61.36-1.18.98-1.18c.47 0 .88.33.98.8a3.997 3.997 0 0 0 4.72 3.12c1.56-.3 2.82-1.56 3.12-3.12A4 4 0 0 0 12 8.5v1.79c0 .45-.54.67-.85.35l-2.8-2.79c-.2-.2-.2-.51 0-.71l2.79-2.79c.32-.31.86-.09.86.36V6.5a6.01 6.01 0 0 1 6 6.24"/></svg>
						</button>
					</div>
					<div class="col-12 col-sm-6 mb-1" *ngIf="order_info.sat_factura && order_info.order.facturacion_mode != 'PER_PAYMENT'">
						<a [href]="getExternalLink('list-order-sat-factura', order_info.order.id)" class="btn btn-primary w-100">Facturas Relacionadas</a>
					</div>
					<ng-container *ngIf="order_info.sat_factura && order_info.order.facturacion_mode != 'PER_PAYMENT'">
						<div class="col-12 col-sm-6 mb-1" *ngIf="order_info?.sat_factura?.xml_attachment_id">
							<a target="_blank" class="btn btn-primary w-100" [href]="getPdfUrl(order_info.order.id)">Ver Factura</a>
						</div>
						<div class="col-12 col-sm-6 mb-1" *ngIf="cancelar_factura_enabled">
							<button class="btn btn-primary w-100" (click)="cancelarFactura()">
								Cancelar Factura
							</button>
						</div>
						<div class="col-12 col-sm-6 mb-1" *ngIf="order_info?.sat_factura?.pdf_attachment_id">
							<button *ngIf="order_info.sat_factura.pdf_attachment_id" class="btn btn-primary w-100" (click)="show_reenviar_factura=true">
								Reenviar Factura
							</button>
						</div>
						<div class="col-12 col-sm-6 mb-1" *ngIf="order_info.sat_factura && order_info.sat_factura.uuid">
							<button class="btn btn-primary w-100" (click)="showNotaCreditoPorImpuestos()">Crear nota de crédito</button>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
		<div class="my-3 col-12 col-md-6" *ngIf="order_info.sat_factura">
			<app-satxmlviewer [xml_attachment_id]="order_info.sat_factura.xml_attachment_id"></app-satxmlviewer>
		</div>
		<div class="col-12 col-lg-6" *ngIf="credit_note_list.length > 0">
			<h2 class="my-3">Notas de Crédito</h2>
			<div class="card p-3">
				<div class="row d-none d-md-flex fw-bold border-bottom">
					<div class="col-2">Fecha</div>
					<div class="col-2">Serie</div>
					<div class="col-1">Folio</div>
					<div class="col-5">UUID</div>
					<div class="col-2 text-end">Monto</div>
				</div>
				<div class="row border-bottom py-2 align-items-center" *ngFor="let nc of credit_note_list">
					<div class="col-12 col-md-2">{{nc.created | shortDate:'full'}}</div>
					<div class="col-4 col-md-2">{{nc.serie || '-'}}</div>
					<div class="col-4 col-md-1">{{nc.folio || '-'}}</div>
					<div class="col-12 col-md-5 text-break">
						<small>{{nc.uuid || 'Sin timbrar'}}</small>
						<span *ngIf="nc.system_cancelled_timestamp || nc.cancelado_por_sat == 'YES'" class="badge bg-danger ms-1">Cancelada</span>
					</div>
					<div class="col-12 col-md-2 text-end fw-bold">
						<ng-container *ngIf="credit_note_amount_map[nc.id] != null; else nc_no_amount">{{credit_note_amount_map[nc.id] | currency}}</ng-container>
						<ng-template #nc_no_amount>-</ng-template>
					</div>
					<div class="col-12 text-end">
						<a *ngIf="nc.uuid" target="_blank" class="btn btn-primary btn-sm m-1" [href]="getCreditNotePdfUrl(nc.id)" title="Ver PDF">Ver PDF</a>
						<a *ngIf="nc.xml_attachment_id" class="btn btn-primary btn-sm m-1" [href]="rest.getFilePath(nc.xml_attachment_id, true)" title="Descargar XML">XML</a>
					</div>
				</div>
				<div class="row py-2 fw-bold">
					<div class="col-6 col-md-10 text-end">Total</div>
					<div class="col-6 col-md-2 text-end">{{creditNoteListTotal() | currency}}</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-lg-6">
			<div class="row align-items-center my-3">
				<div class="col-8 col-md-10">
					<h2>Pagos</h2>
				</div>
				<div class="col-4 col-md-2 text-end" *ngIf="order_info.order.status == 'CLOSED' && this.order_info.order.paid_status != 'PAID'">
					<button class="btn btn-secondary" type="button" (click)="showPaymentForm()">
						<svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 576 512"><path fill="currentColor" d="M251.1 207.1c0-11 9-20 20-20h16c11.9 0 20.9 9 20.9 20v68h4c11 0 20 9 20 20c0 11.9-9 20-20 20h-48.9c-11 0-20-8.1-20-20c0-11 9-20 20-20h4v-47.5c-8.2-1.9-16-9.9-16-20.5zM48.66 79.13C128.4 100.9 208.2 80.59 288 60.25c87-22.17 174-44.35 261-11.87c16.9 6.31 27 23.24 27 41.28V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.7-21.8-159.5-1.5-239.3 18.8c-87.9 22.2-174.9 44.4-261.03 11.9C10.06 457.3 0 440.4 0 422.3V112.5c0-23.91 25.61-39.67 48.66-33.37zM127.1 416c0-35.3-27.75-64-64-64v64h64zm-64-192.9c36.25 0 64-27.8 64-64h-64v64zM512 352v-64.9c-35.3 0-64 29.6-64 64.9h64zm0-256.9h-64c0 36.2 28.7 64 64 64v-64zm-224.9 48c-53 0-96 51-96 112c0 62.8 43 112.9 96 112.9c53.9 0 96.9-50.1 96.9-112.9c0-61-43-112-96.9-112z"/></svg>
						<span class="">&nbsp;Abonar</span>
					</button>
				</div>
			</div>
			<div class="card p-3" *ngIf="order_info">
				<div class="row d-none d-md-flex fw-bold border-bottom">
					<div class="col-4">Fecha</div>
					<div class="col-4">Tipo de pago</div>
					<div class="col-4 text-end">Cantidad</div>
				</div>
				<div class="row border-bottom" *ngIf="payment_info_list.length == 0">
					<div class="col-12 text-center">
						No hay pagos registrados
					</div>
				</div>
				<div *ngFor="let p of active_payment_list">
					<div class="row border-bottom" *ngFor="let bm of p.movements">
						<div class="col-4">
							<a [routerLink]="['/print-payment-receipt',p.payment.id,order_info.order.id]">
								{{p.payment.created | shortDate:'full' }}
							</a>
						</div>
						<div class="col-4">
							{{ payment_type_dic[ bm.bank_movement.transaction_type ]}}
						</div>
						<div class="col-4 text-end">
							{{bm.bank_movement.total | currency}}
							{{bm.bank_movement.currency_id}}
						</div>
						<div class="col-12 text-end">
							<button class="btn btn-primary w-10 m-1" *ngIf="!p.payment.sat_factura_id" (click)="showChangeTransactionType(bm.bank_movement)" title="Cambiar forma de Pago">
								<svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 640 512">
									<path fill="currentColor" d="M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23l-174-.2c-13.3 0-24-10.7-24-24s10.7-24 24-24h174.1zM105 377l-23 23h174c13.3 0 24 10.7 24 24s-10.7 24-24 24H81.9l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64h241.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52h117.4c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0l19.3-19.3V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52H138.6c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64m64 64H96v64c35.3 0 64-28.7 64-64m384 192c-35.3 0-64 28.7-64 64h64zm-224 32a96 96 0 1 0 0-192a96 96 0 1 0 0 192"/>
								</svg>
							</button>
							<button *ngIf="!p.payment.sat_factura_id && rest.current_permission.cancel_payments" class="btn btn-danger w-10 m-1" (click)="cancelarPago(p.payment.id)" title="Cancelar Pago">
								<svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
									<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
								</svg>
							</button>
							<button type="button" *ngIf="(!p.payment.sat_factura_id || (p.payment.sat_factura_id && !p?.sat_factura?.uuid))" class="btn btn-primary m-1" (click)="showFacturarPago(p)" [title]="(order_info.sat_factura || order_info.order.sat_factura_id) ? 'Facturar Pago (Complemento)' : 'Factura Parcial'">
								<svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" class="bi bi-receipt-cutoff" viewBox="0 0 16 16">
									<path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5M11.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"/>
									<path d="M2.354.646a.5.5 0 0 0-.801.13l-.5 1A.5.5 0 0 0 1 2v13H.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H15V2a.5.5 0 0 0-.053-.224l-.5-1a.5.5 0 0 0-.8-.13L13 1.293l-.646-.647a.5.5 0 0 0-.708 0L11 1.293l-.646-.647a.5.5 0 0 0-.708 0L9 1.293 8.354.646a.5.5 0 0 0-.708 0L7 1.293 6.354.646a.5.5 0 0 0-.708 0L5 1.293 4.354.646a.5.5 0 0 0-.708 0L3 1.293zm-.217 1.198.51.51a.5.5 0 0 0 .707 0L4 1.707l.646.647a.5.5 0 0 0 .708 0L6 1.707l.646.647a.5.5 0 0 0 .708 0L8 1.707l.646.647a.5.5 0 0 0 .708 0L10 1.707l.646.647a.5.5 0 0 0 .708 0L12 1.707l.646.647a.5.5 0 0 0 .708 0l.509-.51.137.274V15H2V2.118z"/>
								</svg>
								<span class="ms-1">{{(order_info.sat_factura || order_info.order.sat_factura_id) ? 'Facturar Pago' : 'Factura Parcial'}}</span>
							</button>
							<!--button *ngIf="p.sat_factura.sat_pdf_attachment_id" class="btn btn-primary w-100" (click)="showPdfFile(p?.order?.sat_pdf_attachment_id)">
								Factura
							</button-->
							<a target="_blank" *ngIf="p?.sat_factura?.xml_attachment_id" class="btn btn-primary w-10 m-1" [href]="getPaymentPdfUrl(p.payment.id)" title="Ver Factura">
								<svg _ngcontent-yke-c140="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.1em" height="1.1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 384 512"><path _ngcontent-yke-c140="" d="M181.9 256.1c-5-16-4.9-46.9-2-46.9c8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7c18.3-7 39-17.2 62.9-21.9c-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2c-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8c4.5-18.5 11.6-46.6 6.2-64.2c-4.7-29.4-42.4-26.5-47.8-6.8c-5 18.3-.4 44.1 8.1 77c-11.6 27.6-28.7 64.6-40.8 85.8c-.1 0-.1.1-.2.1c-27.1 13.9-73.6 44.5-54.5 68c5.6 6.9 16 10 21.5 10c17.9 0 35.7-18 61.1-61.8c25.8-8.5 54.1-19.1 79-23.2c21.7 11.8 47.1 19.5 64 19.5c29.2 0 31.2-32 19.7-43.4c-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9c37.1 15.8 42.8 9 42.8 9z" fill="currentColor"></path></svg>
							</a>
							<a [href]="getExternalLink('list-order-sat-factura', order_info.order.id)" class="btn btn-primary w-10 m-1">Facturas Relacionadas</a>
							<button *ngIf="p.payment.sat_factura_id && rest.current_permission.cancelar_factura" class="btn btn-danger w-10 m-1" (click)="cancelarFacturaDelPago(p.payment.sat_factura_id)" title="Cancelar Factura">
								<svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
									<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
								</svg>
							</button>
							<a class="btn btn-primary w-10 m-1" *ngIf="p?.sat_factura?.xml_attachment_id" [href]="rest.getFilePath(p.sat_factura.xml_attachment_id, true)" title="Descargar XML">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-code-fill" viewBox="0 0 16 16">
									<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M6.646 7.646a.5.5 0 1 1 .708.708L5.707 10l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708zm2.708 0 2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 10 8.646 8.354a.5.5 0 1 1 .708-.708"/>
								</svg>
							</a>
							<button class="btn btn-primary w-10 m-1" [routerLink]="['/print-payment-receipt',p.payment.id,order_info.order.id]" title="Ver Pago">
								<svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
									<path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
									<path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
								</svg>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-lg-6" *ngIf="deleted_payment_list.length > 0">
			<h2 class="my-3">Pagos Cancelados</h2>
			<div class="card p-3" *ngIf="order_info">
				<div class="row d-none d-md-flex fw-bold border-bottom">
					<div class="col-3">Fecha de Cancelación</div>
					<div class="col-3">Tipo de pago</div>
					<div class="col-3 text-end">Cantidad</div>
					<div class="col-3 text-end">Acciones</div>
				</div>
				<ng-container *ngFor="let p of deleted_payment_list">
					<div class="row border-bottom" *ngFor="let bm of p.movements">
						<div class="col-3">
							<a [routerLink]="['/print-payment-receipt',p.payment.id,order_info.order.id]">
								{{p.payment.updated | shortDate:'full' }}
							</a>
						</div>
						<div class="col-4 col-md-3">
							{{ payment_type_dic[ bm.bank_movement.transaction_type ]}}
						</div>
						<div class="col-4 col-md-3 text-end">
							{{ bm.bank_movement.total | currency }}
							{{bm.bank_movement.currency_id}}
						</div>
						<div class="col-12 col-md-3 text-end">
							<button class="btn btn-primary w-10 m-1" [routerLink]="['/print-payment-receipt',p.payment.id,order_info.order.id]" title="Ver Pago">
								<svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
									<path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
									<path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
								</svg>
							</button>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="col-12 col-lg-6">
			<h2 class="my-3">Artículos</h2>
			<div class="card">
				<div class="card-body">
					<div class="table-responsive">
						<table class="table">
							<thead class="thead-light">
								<tr>
									<th>Nombre</th>
									<th class="text-end"></th>
									<th class="text-end">Cantidad</th>
									<th class="text-end">P. Unitario</th>
									<th class="text-end">Subtotal</th>
									<th class="text-end">Total</th>
								</tr>
							</thead>
							<tbody *ngIf="order_info">
								<ng-container *ngFor="let io of order_info.items">
									<tr>
										<td class="border-bottom-0 border-top" *ngIf="!io.order_item.item_option_id">
											<img [src]="rest.getImagePath(io.item.image_id,io?.category?.image_id,rest.local_preferences.default_product_image_id)" style="max-height:30px;max-width:30px;margin-right:10px">
											<span *ngIf="io.order_item.delivery_status == 'DELIVERED' && order_info.order.delivery_status == 'DELIVERED'" class="text-success me-1" title="Entregado">
												<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" viewBox="0 0 16 16">
													<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
													<path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
												</svg>
											</span>
											<span *ngIf="!this.rest.current_permission.add_items">{{io.category?.name | titlecase}} - {{io.item.name| titlecase}}</span>
											<a *ngIf="this.rest.current_permission.add_items" [routerLink]="['/edit-item',io.item.id]">{{io.category?.name | titlecase}} - {{io.item.name| titlecase}}</a>
										<app-item-info-button [item_id]="io.item.id" [btn_class]="'btn btn-sm btn-primary ms-1 d-print-none'"></app-item-info-button>
										<button type="button" *ngIf="io.order_item.delivery_status != 'DELIVERED' && order_info.order.status != 'CANCELLED'" class="btn btn-sm btn-success ms-1 d-print-none" (click)="confirmDeliverOrderItem(io, $event)" title="Marcar artículo como entregado">
											<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
												<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
												<path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
											</svg> Entregar
										</button>
											<div *ngIf="io.item.batch_option !== 'NONE'" class="small text-muted align-middle">
												<div  class="d-inline-block me-2">
													<div *ngFor="let batch of getSoldItemBatches(io)">
														<span *ngIf="io.item.batch_option === 'BATCH_ONLY' || io.item.batch_option === 'BATCH_AND_EXPIRATION'">Lote: {{batch.batch}}</span>
														<span *ngIf="io.item.batch_option === 'EXPIRATION_ONLY' || io.item.batch_option === 'BATCH_AND_EXPIRATION'">Cad: {{batch.expiration_date | shortDate:'date'}}</span>
														<span class="ms-1 fw-bold">({{batch.qty}})</span>
													</div>
												</div>
												<button class="btn btn-sm btn-link p-0 ms-2" (click)="showEditBatches(io)" title="Editar lotes">
													<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
														<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821 1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
													</svg>
												</button>
											</div>
											<div *ngFor="let grp of getIngredientBatchGroups(io)" class="small text-muted align-middle mt-1">
												<span class="fw-semibold">{{grp.stock_item?.name || grp.item_exception.description}}: </span>
												<div class="d-inline-block me-2">
													<div *ngFor="let batch of grp.batches" class="d-inline-block me-2">
														<span *ngIf="!grp.stock_item || grp.stock_item.batch_option === 'BATCH_ONLY' || grp.stock_item.batch_option === 'BATCH_AND_EXPIRATION'">Lote: {{batch.batch}}</span>
														<span *ngIf="!grp.stock_item || grp.stock_item.batch_option === 'EXPIRATION_ONLY' || grp.stock_item.batch_option === 'BATCH_AND_EXPIRATION'" class="ms-1">Cad: {{batch.expiration_date | shortDate:'date'}}</span>
														<span class="ms-1 fw-bold">({{batch.qty}})</span>
													</div>
													<span *ngIf="grp.batches.length === 0" class="text-danger">Sin lotes</span>
												</div>
												<button class="btn btn-sm btn-link p-0 ms-1" (click)="showEditBatches(io, grp.item_exception)" title="Editar lotes de ingrediente">
													<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
														<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821 1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
													</svg>
												</button>
											</div>
										</td>
										<td class="" [ngClass]="{'border-0':io.order_item.item_option_id,'border-top':!io.order_item.item_option_id, 'border-bottom-0':!io.order_item.item_option_id}"></td>
										<td class="border-0" *ngIf="io.order_item.item_option_id">
											<span *ngIf="io.order_item.delivery_status == 'DELIVERED' && order_info.order.delivery_status == 'DELIVERED'" class="text-success me-1" title="Entregado">
												<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" fill="currentColor" viewBox="0 0 16 16">
													<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
													<path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
												</svg>
											</span>
											{{io.item.name| titlecase}}
										<app-item-info-button [item_id]="io.item.id" [btn_class]="'btn btn-sm btn-primary ms-1 d-print-none'"></app-item-info-button>
										<button type="button" *ngIf="io.order_item.delivery_status != 'DELIVERED' && order_info.order.status != 'CANCELLED'" class="btn btn-sm btn-success ms-1 d-print-none" (click)="confirmDeliverOrderItem(io, $event)" title="Marcar artículo como entregado">
											<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
												<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
												<path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
											</svg> Entregar
										</button>
											<div *ngIf="io.item.batch_option !== 'NONE'" class="small text-muted">
												<div  class="d-inline-block me-2">
													<div *ngFor="let batch of getSoldItemBatches(io)" class="d-inline-block me-2">
														<span *ngIf="io.item.batch_option === 'BATCH_ONLY' || io.item.batch_option === 'BATCH_AND_EXPIRATION'">Lote: {{batch.batch}}</span>
														<span *ngIf="io.item.batch_option === 'EXPIRATION_ONLY' || io.item.batch_option === 'BATCH_AND_EXPIRATION'">Cad: {{batch.expiration_date | shortDate:'date'}}</span>
														<span class="ms-1 fw-bold">({{batch.qty}})</span>
													</div>
												</div>
												<button class="btn btn-sm btn-link p-0 ms-2" (click)="showEditBatches(io)" title="Editar lotes">
													<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
														<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821 1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
													</svg>
												</button>
											</div>
										</td>
										<td class="text-end" [ngClass]="{'border-0':io.order_item.item_option_id, 'border-top':!io.order_item.item_option_id,'border-bottom-0':!io.order_item.item_option_id}">
											{{io.order_item.qty | number}}
										</td>
										<td class="text-end" [ngClass]="{'border-0':io.order_item.item_option_id,'border-top': !io.order_item.item_option_id, 'border-bottom-0': !io.order_item.item_option_id}">
											<ng-container *ngIf="io.order_item.total">
												{{io.order_item.unitary_price | currency}}
											</ng-container>
										</td>
										<td class="text-end" [ngClass]="{'border-0':io.order_item.item_option_id,'border-top': !io.order_item.item_option_id, 'border-bottom-0': !io.order_item.item_option_id}">
											<ng-container *ngIf="io.order_item.total">
												{{io.order_item.subtotal | currency}}
											</ng-container>
										</td>
										<td class="text-end" [ngClass]="{'border-0':io.order_item.item_option_id, 'border-top': !io.order_item.item_option_id, 'border-bottom-0':!io.order_item.item_option_id}">
											<ng-container *ngIf="io.order_item.total">
												{{io.order_item.total | currency}}
											</ng-container>
										</td>
									</tr>
									<ng-container *ngIf="io.serials.length">
										<tr>
											<td colspan="6">
												<span *ngFor="let serial of io.serials">
													<br>
													{{serial.serial.serial_number}} - {{serial.serial.additional_data}} - {{serial.serial.description}}
												</span>
											</td>
										</tr>
									</ng-container>
								</ng-container>
								<tr *ngIf="order_info.order.discount>0">
									<th colspan="5">Descuento</th>
									<td class="text-end">{{order_info.order.discount | currency}}</td>
								</tr>
								<tr *ngIf="order_info.order.discount>0">
									<th class="fw-bold text-end" colspan="5">subtotal</th>
									<td class="fw-bold text-end">{{order_info.order.total | currency}}</td>
								</tr>
								<tr>
									<th class="fw-bold text-end" colspan="5">Total</th>
									<td class="fw-bold text-end">{{getOrderNetTotal() | currency}} {{order_info.order.currency_id}}</td>
								</tr>
								<tr>
									<th class="fw-bold text-end" colspan="5">Pendiente</th>
									<td class="fw-bold text-end">{{getPendingAmount() | currency}} {{order_info.order.currency_id}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-lg-6" *ngIf="rest.local_preferences.order_attachment_enabled || order_attachment_info_list.length > 0">
			<h2 class="my-3">Archivos Adjuntos</h2>
			<div class="card p-3">
				<div class="row">
					<div class="col-12" *ngIf="order_attachment_info_list.length > 0">
						<app-attachment-gallery class="d-block mb-3" [items]="attachment_gallery_items"></app-attachment-gallery>
					</div>
					<div class="col-12" *ngIf="order_attachment_info_list.length == 0">
						<p class="text-muted">No hay archivos adjuntos</p>
					</div>
					<div class="col-12">
						<label class="fw-bold">Título del adjunto</label>
						<input type="text" name="new_attachment_title" [(ngModel)]="new_attachment_title" class="form-control mb-2" placeholder="Ej. Tablero kilometraje">
						<label class="fw-bold">Agregar nuevo adjunto:</label>
						<app-attachment-uploader
							[default_message]="'Seleccionar archivo'"
							[displayUploadedAttachmentName]="true"
							[containerClasses]="{'d-inline-block': true}"
							[attachment_id]="null"
							(attachmentChange)="onAttachmentUploaded($event)">
						</app-attachment-uploader>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-lg-6" *ngIf="returns_info_list.length > 0">
			<h2 class="my-3">Artículos Cancelados</h2>
			<div class="card">
				<div class="card-body">
					<div class="table-responsive">
						<table class="table">
							<thead class="thead-light">
								<tr>
									<th>Nombre</th>
									<th class="text-center">Tipo</th>
									<th class="text-center">Cantidad</th>
									<th class="text-center">Devolvió</th>
									<th class="text-center">Fecha</th>
									<th class="text-end">Monto</th>
								</tr>
							</thead>
							<tbody *ngIf="order_info">
								<ng-container *ngFor="let return of returns_info_list">
									<tr *ngFor="let items of return.items">
										<td class="text-start">
											{{items.item.name | titlecase}}
										</td>
										<td class="text-center">
											{{ return.returns.type === 'RETURN_MONEY' ? 'Cancelación'
											: (return.returns.type === 'RETURN_COUPON' ? 'Cupón'
											: return.returns.type | titlecase) }}
										</td>
										<td class="text-center">
											{{items.returned_item.returned_qty | number}}
										</td>
										<td class="text-center">
											{{cashier_user.name | titlecase}}
										</td>
										<td class="text-center">
											{{return.returns.created | date:'d/MMM/y h:mma'}}
										</td>
										<td class="text-end">
											{{items.returned_item.total | currency}}
										</td>
									</tr>
								</ng-container>
									<!-- <tr>
										<th class="fw-bold text-end" colspan="4">Total</th>
										<th>AQUI IRA EL TOTAL</th>
									</tr> -->
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-md" *ngIf="has_forms || order_info.responses?.length">
			<h4 class="my-3">Formularios</h4>
			<div class="card p-3">
				<ng-container *ngIf="order_info.responses?.length">
					<div class="row my-1 fw-bold border-bottom">
						<div class="col-12">Formularios de la orden</div>
					</div>
					<div class="border rounded p-2 my-2" *ngFor="let order_response of order_info.responses">
						<app-form-response-viewer [response]="order_response.response" [form]="order_response.form" [answers]="order_response.answers"></app-form-response-viewer>
					</div>
				</ng-container>
				<ng-container *ngFor="let coii_response of coii_response_list">
					<div class="row my-1 fw-bold border-bottom">
						<div class="col-6">{{coii_response.form.title}}</div>
						<div class="col-6 text-end">
							<button *ngIf="coii_response.order_item.qty>coii_response.responses.length" (click)="showAgregarResponse(coii_response)">+</button>
						</div>
					</div>
					<div class="row my-1 ms-0 me-0" *ngFor="let response of coii_response.responses">
						<div class="col-4 p-0 fw-bold">
							{{coii_response | itemName}} -
							<a [routerLink]="['/edit-response',response.response.id]">
								{{response.response.title}}
							</a>
						</div>
						<div class="col-2 p-0 fw-bold">
							{{response?.serial?.serial_number | titlecase}}
						</div>
						<div class="col-2 p-0 text-end">{{response.response.created | shortDate: 'full'}}</div>
						<div class="col-4 p-0 text-end">
							<button type="button" class="btn btn-primary" (click)="showChangeSerial(response)" title="Cambiar Serial">
								Cambiar
							</button>
						</div>
						<details *ngIf="response.answers?.length" class="col-12 p-0 mt-1">
							<summary class="fw-bold small" style="cursor:pointer">Ver respuestas</summary>
							<app-form-response-viewer class="d-block mt-1" [response]="response.response" [form]="coii_response.form" [answers]="response.answers"></app-form-response-viewer>
						</details>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="col-12 col-lg-6" *ngIf="cinstallment_list.length > 0">
			<h4 class="p-3 my-3">Registro de plazos</h4>
			<div class="card">
				<div class="card-body">
					<div class="table-responsive">
						<table class="table">
							<thead class="thead-light">
								<tr>
									<th>#</th>
									<th class="text-end">Vencimiento</th>
									<th class="d-none d-md-table-cell text-end">Estatus</th>
									<th class="text-end">Monto</th>
									<th class="text-end">Abonado</th>
									<th class="d-none d-md-table-cell text-end">Fecha Saldado</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let installment of paginatedInstallments">
									<tr [ngClass]="{'bg-danger':installment.due_status == 'VENCIDO','text-white':installment.due_status == 'VENCIDO'}">
										<td>{{installment.installment_number}}</td>
										<td class="text-end">{{installment.due_date | shortDate:'full'}}</td>
										<td class="d-none d-md-table-cell text-end fw-bold">
											{{installment.due_status | titlecase}}
										</td>
										<td class="text-end">{{installment.amount | currency}}</td>
										<td class="text-end">{{installment.paid_amount | currency}}</td>
										<td class="d-none d-md-table-cell text-end">{{installment.paid_timestamp | shortDate:'full'}}</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
					<div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalPages > 1">
						<button class="btn btn-primary btn-sm" (click)="goToFirstPage()" [disabled]="currentPage === 1">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
								<path fill-rule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
							</svg>
						</button>
						<button class="btn btn-primary btn-sm" (click)="previousPage()" [disabled]="currentPage === 1">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
							</svg>
						</button>
						<span>Página {{currentPage}} de {{totalPages}}</span>
						<button class="btn btn-primary btn-sm" (click)="nextPage()" [disabled]="currentPage === totalPages">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
							</svg>
						</button>
						<button class="btn btn-primary btn-sm" (click)="goToLastPage()" [disabled]="currentPage === totalPages">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
								<path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"/>
								<path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"/>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="is_local">
		<button type="button" (click)="printUsbExterna($event)">Print MTF</button>
		<button type="button" (click)="initPrinter($event)">InitPrinter</button>
	</div>
</div>

<app-modal [show]="show_add_payment_to_order" [biggest_posible]="true" [closable]="false" *ngIf="show_add_payment_to_order">
	<app-add-client-payment [currency_rate_list]="currency_rate_list" [order_info_list]="client_order_info_list" (onPayment)="onPayment($event)"></app-add-client-payment>
</app-modal>

<app-modal [(show)]="show_facturar">
	<div *ngIf="order_info">
		<app-save-order-factura [order_info]="order_info" (onFinish)="onTerminoFacturar($event)" [billing_data_list]="billing_data_list"></app-save-order-factura>
	</div>
</app-modal>
<app-modal [(show)]="show_reenviar_factura" [closable]="false">
	<div class="container-fluid" *ngIf="order_info">
		<h2>Reenviar Factura por Correo</h2>
		<form name="send_factura_form" (submit)="resendFactura($event)" ngNativeValidate>
			<app-loading [is_loading]="is_loading"></app-loading>
			<div class="row">
				<div class="col-12 col-md-6">
					<label>Nombre</label>
					<input type="text" name="name" [(ngModel)]="reenviar_factura_name" class="form-control">
				</div>
				<div class="col-12 col-md-6">
					<label>Correo Electrónico</label>
					<input type="text" name="factura_email" [(ngModel)]="reenviar_factura_email" class="form-control" placeholder='correo@ejemplo.com, "Nombre" <correo@ejemplo.com>' required>
				</div>
			</div>
			<div class="row py-3">
				<div class="col-6">
					<button type="button" class="btn btn-primary w-100" (click)="show_reenviar_factura=false" [disabled]="is_loading">Cancelar</button>
				</div>
				<div class="col-6">
					<button type="submit" class="btn btn-primary w-100">Enviar</button>
				</div>
			</div>
		</form>
	</div>
</app-modal>

<app-modal [(show)]="show_refacturar" [closable]="false">
	<div class="container-fluid" *ngIf="order_info">
		<h2>Reiniciar Facturación</h2>
		<form name="reset_factura_form" (submit)="resetFacturacion($event)" ngNativeValidate>
			<app-loading [is_loading]="is_loading"></app-loading>
			<div class="row">
				<div class="col-12 col-md-6">
					<label>Forma de Pago</label>
					<select class="form-control" name="sat_forma_pago" [(ngModel)]="sat_forma_pago">
						<option value="">Seleccionar</option>
						<option value="01">Efectivo</option>
						<option value="02">Cheque</option>
						<option value="05">Monedero Electrónico</option>
						<option value="04">Tarjeta de crédito</option>
						<option value="28">Tarjeta de débito</option>
						<option value="03">Transferencia</option>
					</select>
				</div>
			</div>
			<div class="row py-3">
				<div class="col-6">
					<button type="button" class="btn btn-primary w-100" (click)="show_refacturar=false" [disabled]="is_loading">Cancelar</button>
				</div>
				<div class="col-6">
					<button type="submit" class="btn btn-primary w-100">Reiniciar</button>
				</div>
			</div>
		</form>
	</div>
</app-modal>

<!-- Complemento de Pago — legacy production workflow (order already invoiced as a whole): keep original simple form -->
<app-modal [(show)]="show_facturar_pago">
	<div class="container-fluid" *ngIf="order_info">
		<h2>Facturar el pago</h2>
		<p class="mb-1"><strong>ID del pago:</strong> {{selected_payment?.payment?.id}}</p>
		<p class="mb-2"><strong>ID de la orden:</strong> {{order_info?.order?.id}}</p>
		<app-loading [is_loading]="is_loading"></app-loading>
		<form name="facturar_tfp" (submit)="facturarElPago($event)" ngNativeValidate>
			<div class="row">
				<div class="col-12">
					<label>Fecha de pago</label>
					<input type="datetime-local" class="form-control" name="fecha_pago" [(ngModel)]="fecha_pago" required>
				</div>
				<div class="col-12">
					<label>Serie</label>
					<input type="text" class="form-control" name="sat_serie" [(ngModel)]="sat_serie" minlength="1" maxlength="25" required>
				</div>
				<div class="col-12">
					<label>Correo Electrónico</label>
					<input type="text" name="pago_factura_email" [(ngModel)]="pago_factura_email" class="form-control" placeholder='correo@ejemplo.com, "Nombre" <correo@ejemplo.com>' required>
				</div>
			</div>
			<div class="row py-3">
				<div class="col-6">
					<button type="button" class="btn btn-primary w-100" (click)="show_facturar_pago=false" [disabled]="is_loading">Cancelar</button>
				</div>
				<div class="col-6">
					<button type="submit" class="btn btn-primary w-100">Facturar Pago</button>
				</div>
			</div>
		</form>
	</div>
</app-modal>

<!-- Facturación por pago (PER_PAYMENT / order not invoiced as a whole): full invoice-data form -->
<app-modal [(show)]="show_facturar_pago_full">
	<div *ngIf="order_info && selected_payment">
		<app-save-order-factura
			[order_info]="order_info"
			[payment_mode]="true"
			[selected_payment]="selected_payment"
			(onFinish)="onTerminoFacturarPago($event)"
			[billing_data_list]="billing_data_list">
		</app-save-order-factura>
	</div>
</app-modal>

<app-modal [(show)]="show_change_transaction_type">
	<div class="container-fluid p-3" *ngIf="order_info">
		<form (submit)="changeTransactionType($event)">
			<div class="row">
				<div class="col-12 form-group">
					<label>Forma de Pago</label>
					<select name="transaction_type" [(ngModel)]="transaction_type" class="form-control" required>
						<option value="CASH">Efectivo</option>
						<option value="CHECK">Cheque</option>
						<option value="TRANSFER">Transferencia</option>
						<option value="CREDIT_CARD">Tarjeta de crédito</option>
						<option value="DEBIT_CARD">Tarjeta de débito</option>
					</select>
				</div>
				<div class="col-6 my-3">
					<button type="button" class="btn btn-primary w-100" (click)="show_change_transaction_type=false">Cancelar</button>
				</div>
				<div class="col-6 my-3">
					<button type="submit" class="btn btn-primary w-100">Cambiar</button>
				</div>
			</div>
		</form>
	</div>
</app-modal>

<app-modal [(show)]="show_assign_response">
	<div class="container-fluid p-3" *ngIf="order_info">
		<form (submit)="submitOrderItemResponse($event)">
			<div class="row">
				<div class="col-12 form-group">
					<label>Respuesta</label>
					<select name="selected_response_id" [ngModel]="selected_response_id" (ngModelChange)="onSelectedResponse($event)" class="form-control" required>
						<option value="">Seleccionar</option>
						<option *ngFor="let response_info of response_info_list" [value]="response_info.response.id">
							{{response_info.response.title}}
						</option>
					</select>
				</div>
				<div class="col-12 form-group">
					<label>#Serie Codigo</label>
					<input type="text"  name="serial_number" [(ngModel)]="serial_number" class="form-control">
				</div>
				<div class="col-6 my-3">
					<button type="button" class="btn btn-primary w-100" (click)="show_assign_response=false">Cancelar</button>
				</div>
				<div class="col-6 my-3">
					<button type="submit" class="btn btn-primary w-100">Agregar {{selected_form?.title}}</button>
				</div>
			</div>
		</form>
	</div>
</app-modal>

<app-modal [(show)]="show_confirm_cancel" [closable]="false">
	<app-loading [is_loading]="is_loading"></app-loading>
	<div class="container-fluid p-3">
		<h3>¿Está seguro que desea cancelar esta orden?</h3>
		<p class="fw-bold">Esta acción no se puede deshacer</p>

		<form (submit)="confirmCancelOrder($event)" ngNativeValidate>
			<div class="row">
				<div class="col-12 form-group">
					<label>Motivo de cancelación</label>
					<textarea name="cancel_reason" [(ngModel)]="cancel_reason" class="form-control" required></textarea>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col-6">
					<button type="button" class="btn btn-secondary w-100" (click)="show_confirm_cancel=false">No</button>
				</div>
				<div class="col-6">
					<button type="submit" class="btn btn-danger w-100">Sí, cancelar</button>
				</div>
			</div>
		</form>
	</div>
</app-modal>

<app-modal [(show)]="show_change_serial">
	<form (submit)="submitSerial($event)">
		<div class="container-fluid p-3">
			<div class="row">
				<div class="col-12 form-group">
					<label>#Serial</label>
					<input type="text"  name="serial_number" [(ngModel)]="serial_number" class="form-control">
				</div>
				<div class="col-6 my-3">
					<button type="button" class="btn btn-primary w-100" (click)="show_change_serial=false">Cancelar</button>
				</div>
				<div class="col-6 my-3">
					<button type="submit" class="btn btn-primary w-100">Cambiar</button>
				</div>
			</div>
		</div>
	</form>
</app-modal>

<app-modal [(show)]="show_agregar_nota_credito">
	<div class="p-3">
		<h4>Generar Nota de Crédito</h4>
		<app-loading [is_loading]="is_loading"></app-loading>
		<p>Selecciona el motivo de la nota de crédito:</p>
		<select class="form-select mb-3" [(ngModel)]="credit_note_motivo" [disabled]="is_loading">
			<option value="01">Nota de crédito de los documentos relacionados</option>
			<option value="02">Devolución de mercancías sobre facturas o traslados previos</option>
		</select>
		<label>Monto a devolver:</label>
		<input type="number" class="form-control mb-3" [(ngModel)]="credit_note_amount" [disabled]="is_loading">
		<div class="row">
			<div class="col-6">
				<button class="btn btn-secondary w-100" (click)="show_agregar_nota_credito=false" [disabled]="is_loading">Cancelar</button>
			</div>
			<div class="col-6">
				<button class="btn btn-danger w-100" (click)="generateCreditNote()" [disabled]="is_loading">Generar</button>
			</div>
		</div>
	</div>
</app-modal>

<app-modal [(show)]="show_nota_credito_grupos">
	<div class="p-3">
		<h4>Nota de Crédito por Impuestos</h4>
		<app-loading [is_loading]="is_loading"></app-loading>
		<p>Combinaciones de impuestos de la factura. Captura el monto a acreditar de cada combinación (con impuestos incluidos, 0 para omitir):</p>
		<div class="row mb-3">
			<div class="col-12 col-md-6">
				<label>Forma de pago</label>
				<select class="form-select" [(ngModel)]="credit_note_forma_pago" [disabled]="is_loading">
					<option *ngFor="let option of credit_note_forma_pago_options" [value]="option.value">{{option.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-6">
				<label>Serie</label>
				<input type="text" class="form-control" [(ngModel)]="credit_note_serie" [disabled]="is_loading">
			</div>
		</div>
		<div class="alert alert-warning" *ngIf="credit_note_ungrouped_count > 0">
			{{credit_note_ungrouped_count}} concepto(s) ({{credit_note_ungrouped_total | currency}}) no tienen impuestos identificables en el XML y no se pueden acreditar con esta herramienta.
		</div>
		<div class="table-responsive">
			<table class="table table-sm table-bordered align-middle">
				<thead class="table-light">
					<tr>
						<th>Combinación</th>
						<th class="text-end">Total factura</th>
						<th>Monto a acreditar</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of credit_note_group_rows">
						<td>
							<div class="fw-bold">{{row.label}}</div>
							<small class="text-muted">{{row.concepto_count}} concepto(s)</small>
							<small class="text-muted d-block" *ngIf="row.note">{{row.note}}</small>
						</td>
						<td class="text-end">{{row.xml_total | currency}}</td>
						<td><input type="number" class="form-control form-control-sm" style="min-width:110px" [(ngModel)]="row.amount" [disabled]="is_loading" min="0" [max]="row.xml_total" step="0.01"></td>
					</tr>
				</tbody>
			</table>
		</div>
		<p class="text-end fw-bold">Total a acreditar: {{creditNoteGroupsTotal() | currency}} (Pendiente: {{getPendingAmount() | currency}})</p>
		<div class="row">
			<div class="col-6">
				<button class="btn btn-secondary w-100" (click)="show_nota_credito_grupos=false" [disabled]="is_loading">Cancelar</button>
			</div>
			<div class="col-6">
				<button class="btn btn-danger w-100" (click)="generateCreditNoteByGroups()" [disabled]="is_loading">Generar</button>
			</div>
		</div>
	</div>
</app-modal>

<app-modal [(show)]="show_edit_batches">
	<div class="container-fluid p-3">
		<h4>Editar Lotes</h4>
		<p class="text-muted mb-1">{{edit_batch_item?.item?.name}}</p>
		<p class="small fw-semibold text-primary" *ngIf="edit_batch_exception">
			Ingrediente: {{edit_batch_stock_item?.name || edit_batch_exception.description}}
		</p>
		<app-loading [is_loading]="is_loading"></app-loading>

		<div class="row">
			<div class="col-12 mb-3">
				<h6 class="mb-0">
					Lotes disponibles en almacen
					<span class="fw-bold">(Req: {{requiredBatchQty}})</span>
				</h6>
				<div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
					<table class="table table-sm table-bordered">
						<thead class="table-light">
							<tr>
								<th>Lote</th>
								<th>Caducidad</th>
								<th>Cantidad</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let batch of paginatedAvailableBatches">
								<td>{{batch.batch || '-'}}</td>
								<td>{{batch.expiration_date | shortDate:'date'}}</td>
								<td>{{batch.qty}}</td>
								<td>
									<button class="btn btn-sm btn-outline-primary" (click)="selectAvailableBatch(batch)" title="Agregar">
										<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
											<path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
										</svg>
									</button>
								</td>
							</tr>
							<tr *ngIf="available_batches.length === 0">
								<td colspan="4" class="text-center text-muted">Sin lotes disponibles</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="d-flex justify-content-between align-items-center mt-2" *ngIf="batchTotalPages > 1">
					<button class="btn btn-sm btn-outline-secondary" (click)="prevBatchPage()" [disabled]="batch_page === 0">
						<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
							<path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
						</svg>
					</button>
					<span class="small">{{batchCurrentPage}} / {{batchTotalPages}}</span>
					<button class="btn btn-sm btn-outline-secondary" (click)="nextBatchPage()" [disabled]="batch_page >= batchTotalPages - 1">
						<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
							<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
						</svg>
					</button>
				</div>
			</div>

			<div class="col-12">
				<h6 class="mb-0">
					Lotes en la orden
					<span class="fw-bold">(Total: {{editBatchesTotal}})</span>
				</h6>
				<div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
					<table class="table table-sm table-bordered">
						<thead class="table-light">
							<tr>
								<th>Lote</th>
								<th>Caducidad</th>
								<th>Cantidad</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let batch of edit_batches; let i = index">
								<td>
									<input type="text" class="form-control form-control-sm" [(ngModel)]="batch.batch" [disabled]="editBatchTargetOption === 'EXPIRATION_ONLY'">
								</td>
								<td>
									<input type="date" class="form-control form-control-sm" [(ngModel)]="batch.expiration_date" [disabled]="editBatchTargetOption === 'BATCH_ONLY'">
								</td>
								<td>
									<input type="number" class="form-control form-control-sm" [(ngModel)]="batch.qty" min="0" step="any" style="width: 70px;">
								</td>
								<td>
									<button class="btn btn-sm btn-outline-danger" (click)="removeBatchRow(i)">
										<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
											<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
										</svg>
									</button>
								</td>
							</tr>
							<tr *ngIf="edit_batches.length === 0">
								<td colspan="4" class="text-center text-muted">Sin lotes</td>
							</tr>
						</tbody>
					</table>
				</div>
				<button class="btn btn-sm btn-outline-secondary mt-2" (click)="addBatchRow()">+ Agregar</button>
			</div>
		</div>

		<div class="row mt-3">
			<div class="col-6">
				<button class="btn btn-secondary w-100" (click)="show_edit_batches=false">Cancelar</button>
			</div>
			<div class="col-6">
				<button class="btn btn-primary w-100" (click)="saveBatches()">Guardar</button>
			</div>
		</div>
	</div>
</app-modal>
